// import sideBarDefaultLogoDarkMode from "@assets/images/sidebar-deafult-logo-darkMode.png";
// import sideBarDefaultLogo from "@assets/images/sidebar-default-logo.png";
import evolveLogo from "@assets/images/evolve-logo.png";
import evolveWhiteLogo from "@assets/images/evolve-white-logo.png";
import { useUser } from "@dashboard/auth";
import { useLegacyThemeHandler } from "@dashboard/components/Sidebar/user/Controls";
import { Box, Text } from "@saleor/macaw-ui-next";
import React from "react";

export const MountingPoint = () => {
  const { theme } = useLegacyThemeHandler();
  const logo = theme === "defaultLight" ? evolveLogo : evolveWhiteLogo;
  const { user } = useUser();

  return (
    <Box display="flex" gap={3} paddingX={4} paddingY={5} alignItems="center">
      {/* <Avatar.Store src={logo} scheme="accent1" size="small" /> */}
      <img src={logo} alt="Evolve Logo" width={27} height={27} />
      <Text size={3} fontWeight="bold">
        {user?.isVendor ? "Vendor Dashboard" : "Admin Dashboard"}
      </Text>
    </Box>
  );
};
